export class AddressDTO {
    id: number;
    userId: number;
    street: string;
    suburb: string;
    city: string;
    postalCode: string;
    provinceId: number;
    country: string;
}